import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiTitle } from '@taiga-ui/core';
import { TuiHeader } from '@taiga-ui/layout';

@Component({
    selector: 'ffx-page-header',
    standalone: true,
    imports: [CommonModule, TuiHeader, TuiTitle],
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
    @Input() title = 'Title';
    @Input() subtitle = 'Subtitle';
}
